export function min(numbers: number[]) {
  if (numbers.length === 0) return NaN
  let result = numbers[0]
  numbers.forEach(n => (result = Math.min(result, n)))
  return result
}

export function max(numbers: number[]) {
  if (numbers.length === 0) return NaN
  let result = numbers[0]
  numbers.forEach(n => (result = Math.max(result, n)))
  return result
}
